// @ts-nocheck
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['form', 'title', 'text', 'file'];
  static values = {
    enabled: { type: Boolean, default: true },
  };

  connect() {
    this.initialData = this.getFormData();
    this.hasChanges = false;
    this.isSubmitting = false;

    // バウンド関数を変数に保存
    this._onFormChange = this.onFormChange.bind(this);
    this._onFormSubmit = this.onFormSubmit.bind(this);
    this._onBeforeUnload = this.onBeforeUnload.bind(this);

    this.setupEventListeners();
  }

  disconnect() {
    this.removeEventListeners();
  }

  setupEventListeners() {
    // フォーム要素の変更を監視
    const targetEventMap = [
      { has: 'hasTitleTarget', target: 'titleTarget', event: 'input', handler: this._onFormChange },
      { has: 'hasTextTarget', target: 'textTarget', event: 'input', handler: this._onFormChange },
      { has: 'hasFileTarget', target: 'fileTarget', event: 'change', handler: this._onFormChange },
    ];

    targetEventMap.forEach(({ has, target, event, handler }) => {
      if (this[has]) {
        this[target].addEventListener(event, handler);
      }
    });

    // フォーム送信時の処理
    if (this.hasFormTarget) {
      this.formTarget.addEventListener('submit', this._onFormSubmit);
    }

    // ページ離脱時の確認
    window.addEventListener('beforeunload', this._onBeforeUnload);
  }

  removeEventListeners() {
    const targetEventMap = [
      { has: 'hasTitleTarget', target: 'titleTarget', event: 'input', handler: this._onFormChange },
      { has: 'hasTextTarget', target: 'textTarget', event: 'input', handler: this._onFormChange },
      { has: 'hasFileTarget', target: 'fileTarget', event: 'change', handler: this._onFormChange },
    ];

    targetEventMap.forEach(({ has, target, event, handler }) => {
      if (this[has]) {
        this[target].removeEventListener(event, handler);
      }
    });

    if (this.hasFormTarget) {
      this.formTarget.removeEventListener('submit', this._onFormSubmit);
    }

    window.removeEventListener('beforeunload', this._onBeforeUnload);
  }

  onFormChange() {
    if (!this.enabledValue) return;

    const currentData = this.getFormData();
    this.hasChanges = !this.isDataEqual(this.initialData, currentData);
  }

  onFormSubmit() {
    this.isSubmitting = true;
    this.hasChanges = false;
  }

  onBeforeUnload(event) {
    if (!this.enabledValue || this.isSubmitting || !this.hasChanges) {
      return;
    }

    // 標準的な確認メッセージを表示
    event.preventDefault();
    event.returnValue = '入力内容が保存されていません。このページを離れますか？';
    return event.returnValue;
  }

  getFormData() {
    const data = {};

    const targetDataMap = [
      {
        has: 'hasTitleTarget',
        target: 'titleTarget',
        key: 'title',
        getValue: () => this.titleTarget.value || '',
      },
      {
        has: 'hasTextTarget',
        target: 'textTarget',
        key: 'text',
        getValue: () => this.textTarget.value || '',
      },
      {
        has: 'hasFileTarget',
        target: 'fileTarget',
        key: 'file',
        getValue: () => this.fileTarget.files.length > 0,
      },
    ];

    targetDataMap.forEach(({ has, key, getValue }) => {
      if (this[has]) {
        data[key] = getValue();
      }
    });

    return data;
  }

  isDataEqual(data1, data2) {
    return JSON.stringify(data1) === JSON.stringify(data2);
  }

  // 外部から呼び出せるメソッド
  disable() {
    this.enabledValue = false;
  }

  enable() {
    this.enabledValue = true;
  }

  reset() {
    this.initialData = this.getFormData();
    this.hasChanges = false;
  }
}
